export const musiques = (state) => state.musiques